import { motion } from "framer-motion";
import {
  ShieldCheck,
  BadgeCheck,
  PoundSterling,
  Timer,
  Building2,
  Smile,
} from "lucide-react";

const items = [
  {
    icon: ShieldCheck,
    title: "Reliable Service",
    desc: "Turn up on time. Get the job done. Leave the place clean.",
  },
  {
    icon: BadgeCheck,
    title: "Qualified Professionals",
    desc: "Certified, insured and experienced engineers across every trade.",
  },
  {
    icon: PoundSterling,
    title: "Competitive Pricing",
    desc: "Honest, transparent quotes — no hidden fees, no surprises.",
  },
  {
    icon: Timer,
    title: "Fast Response Times",
    desc: "Same-day callouts available for urgent issues and emergencies.",
  },
  {
    icon: Building2,
    title: "Domestic & Commercial",
    desc: "Homes, offices, landlords and managed property portfolios.",
  },
  {
    icon: Smile,
    title: "Customer Satisfaction",
    desc: "We measure success by repeat clients and personal referrals.",
  },
];

export default function WhyChooseUs() {
  return (
    <section
      id="why-choose-us"
      data-testid="why-section"
      className="bg-[#0A192F] text-white py-20 md:py-32 pbs-grain relative"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-white/60">
            Why Choose Us
          </span>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-bold tracking-tight text-white">
            A trades partner that actually answers the phone.
          </h2>
          <p className="mt-6 text-white/75 leading-relaxed">
            We built Perficient around the things customers tell us matter
            most — turning up, communicating clearly, and finishing the job
            properly.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10 rounded-md overflow-hidden">
          {items.map((it, idx) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.title}
                data-testid={`why-item-${idx}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: idx * 0.05 }}
                className="bg-[#0A192F] p-8 md:p-10 hover:bg-[#0F243F] transition-colors"
              >
                <Icon className="w-7 h-7 text-white" strokeWidth={1.5} />
                <h3 className="mt-5 font-heading text-lg font-semibold text-white">
                  {it.title}
                </h3>
                <p className="mt-2 text-white/70 text-sm leading-relaxed">
                  {it.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
